export { NextImage } from './next-image'
